import _ from 'lodash';
import DateHelper from '../../utilities/DateHelper';
import LadderLocalStorage from '../../utilities/LadderLocalStorage';
import Request from '../../utilities/Request';
import CategoryGroup from '../../models/CategoryGroup';
import Category from '../../models/Category';
import Transaction from '../../models/Transaction';
import Budget from '../../models/Budget';
import { retrieveBankAccountTransactionsIfNecessary } from './plaid';
import clearCaches from "../../utilities/clearCaches";
import { confirmLosingUnsentFoodOps, forgetFoodData } from "./food.js";
import BudgetListModes from "../../react/components/BudgetListModes";
import generateUuid from "../../utilities/generateUuid.js";
import { getLogin } from "./login.js";
import PlaidTransaction from "models/PlaidTransaction";
import PlaidBankAccount from "models/PlaidBankAccount";
import { monthsBetween, selectionFromMonths } from "../../utilities/monthSelection.js";

export const UPDATE_SELECTED_DATE = 'UPDATE_SELECTED_DATE';

export const LOGOUT_BEGIN = 'LOGOUT_BEGIN';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const SET_PLAYER = 'SET_PLAYER';

export const CREATED_ACCOUNT = 'CREATED_ACCOUNT';
export const SIGNED_IN = 'SIGNED_IN';


export const CHANGE_BUDGET_LIST_MODE = 'CHANGE_BUDGET_LIST_MODE';

export const ADD_CLONED_TRANSACTION = 'ADD_CLONED_TRANSACTION';
export const REPLACE_PREVIOUS_TRANSACTION = 'REPLACE_PREVIOUS_TRANSACTION';

export const START_TRANSACTION_EDIT_MODE = 'START_TRANSACTION_EDIT_MODE';
export const END_TRANSACTION_EDIT_MODE = 'END_TRANSACTION_EDIT_MODE';

export const CONNECTION_ONLINE = 'CONNECTION_ONLINE';
export const CONNECTION_OFFLINE = 'CONNECTION_OFFLINE';
export const SET_SELECTED_MAIN_TAB = 'SET_SELECTED_MAIN_TAB';
export const DELETE_ALL_TRANSACTIONS_POPUP_SHOW = 'DELETE_ALL_TRANSACTIONS_POPUP_SHOW';
export const DELETE_ALL_TRANSACTIONS_POPUP_HIDE = 'DELETE_ALL_TRANSACTIONS_POPUP_HIDE';
export const DELETE_ALL_TRANSACTIONS_BEGIN = 'DELETE_ALL_TRANSACTIONS_BEGIN';
export const DELETE_ALL_TRANSACTIONS_SUCCESS = 'DELETE_ALL_TRANSACTIONS_SUCCESS';
export const DELETE_ALL_TRANSACTIONS_FAIL = 'DELETE_ALL_TRANSACTIONS_FAIL';

export const UPDATE_REFRESH_CACHE_CHECK_BEGIN = 'UPDATE_REFRESH_CACHE_CHECK_BEGIN';
export const UPDATE_CATEGORY_GROUPS_BEGIN = 'UPDATE_CATEGORY_GROUPS_BEGIN';
export const UPDATE_TRANSACTIONS_BEGIN = 'UPDATE_TRANSACTIONS_BEGIN';
export const UPDATE_BUDGETS_BEGIN = 'UPDATE_BUDGETS_BEGIN';
export const UPDATE_REFRESH_SUCCESS = 'UPDATE_REFRESH_SUCCESS';
export const UPDATE_REFRESH_CACHE_CHECK_SUCCESS = 'UPDATE_REFRESH_CACHE_CHECK_SUCCESS';
export const UPDATE_REFRESH_CACHE_CHECK_FAIL = 'UPDATE_REFRESH_CACHE_CHECK_FAIL';
export const UPDATE_REFRESH_FAIL = 'UPDATE_REFRESH_FAIL';

export const ADD_BANK_TRANSACTION_AS_TRANSACTION_SUCCESS = 'ADD_BANK_TRANSACTION_AS_TRANSACTION_SUCCESS';
export const ADD_BANK_TRANSACTION_AS_TRANSACTION_FAIL = 'ADD_BANK_TRANSACTION_AS_TRANSACTION_FAIL';
export const ADD_BANK_TRANSACTION_AS_TRANSACTION_CANCELLED = 'ADD_BANK_TRANSACTION_AS_TRANSACTION_CANCELLED';

export const HIDE_BANK_TRANSACTION_BEGIN = 'HIDE_BANK_TRANSACTION_BEGIN';
export const HIDE_BANK_TRANSACTION_SUCCESS = 'HIDE_BANK_TRANSACTION_SUCCESS';
export const HIDE_BANK_TRANSACTION_FAIL = 'HIDE_BANK_TRANSACTION_FAIL';

export const TOGGLE_SHOW_HIDDEN_BANK_TRANSACTIONS = 'TOGGLE_SHOW_HIDDEN_BANK_TRANSACTIONS';

export const LAST_EDITED_TRANSACTION_CHANGED = 'LAST_EDITED_TRANSACTION_CHANGED';

export const SUMMARY_PAGE_TAB_CHANGE = 'SUMMARY_PAGE_TAB_CHANGE';

export const CATEGORY_FLIP_TRANSACTIONS_BEGIN = 'CATEGORY_FLIP_TRANSACTIONS_BEGIN';
export const CATEGORY_FLIP_TRANSACTIONS_SUCCESS = 'CATEGORY_FLIP_TRANSACTIONS_SUCCESS';
export const CATEGORY_FLIP_TRANSACTIONS_ERROR = 'CATEGORY_FLIP_TRANSACTIONS_ERROR';

export const BUDGET_SUB_TAB_CHANGED = 'BUDGET_SUB_TAB_CHANGED';

export const SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_BEGIN = 'SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_BEGIN';
export const SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_SUCCESS = 'SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_SUCCESS';
export const SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_ERROR = 'SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_ERROR';

export const SUBMIT_CATEGORY_BUDGET_UPDATE_BEGIN = 'SUBMIT_CATEGORY_BUDGET_UPDATE_BEGIN';
export const SUBMIT_CATEGORY_BUDGET_UPDATE_ERROR = 'SUBMIT_CATEGORY_BUDGET_UPDATE_ERROR';
export const SUBMIT_CATEGORY_BUDGET_UPDATE_SUCCESS = 'SUBMIT_CATEGORY_BUDGET_UPDATE_SUCCESS';

export const HIGHLIGHTED_CATEGORY = 'HIGHLIGHTED_CATEGORY';
export const UN_HIGHLIGHTED_CATEGORY = 'UN_HIGHLIGHTED_CATEGORY';

export const HIGHLIGHTED_TRANSACTION = 'HIGHLIGHTED_TRANSACTION';
export const UN_HIGHLIGHTED_TRANSACTION = 'UN_HIGHLIGHTED_TRANSACTION';

export const SHOW_ONLY_UNCATEGORIZED_TRANSACTIONS = 'SHOW_ONLY_UNCATEGORIZED_TRANSACTIONS';
export const HIDE_ONLY_UNCATEGORIZED_TRANSACTIONS = 'HIDE_ONLY_UNCATEGORIZED_TRANSACTIONS';

export const SET_CATEGORY_AS_SUBGROUP_MODE_ACTIVE = 'SET_CATEGORY_AS_SUBGROUP_MODE_ACTIVE';
export const SET_CATEGORY_AS_SUBGROUP_MODE_DEACTIVE = 'SET_CATEGORY_AS_SUBGROUP_MODE_DEACTIVE';

export const RESET_CATEGORIES_BEGIN = 'RESET_CATEGORIES_BEGIN';
export const RESET_CATEGORIES_SUCCESS = 'RESET_CATEGORIES_SUCCESS';
export const RESET_CATEGORIES_FAIL = 'RESET_CATEGORIES_FAIL';

export const login = (email, password) => {

};

export const setShowOnlyUncategorizedTransactions = (set) => {
	return {
		type: set === true ? SHOW_ONLY_UNCATEGORIZED_TRANSACTIONS : HIDE_ONLY_UNCATEGORIZED_TRANSACTIONS
	};
};

/**
 * Logs out, after asking when changes made offline have not been sent: logging out deletes them.
 * Resolves false when the user chose to stay.
 */
export const logout = ({ reload = () => window.location.reload() } = {}) => (dispatch) => dispatch(confirmLosingUnsentFoodOps()).then((confirmed) => {
	if(!confirmed) {
		return false;
	}
	return signOut(dispatch, true, reload);
});

/**
 * Signs out after the server has said the session is gone (a 401), without asking and without
 * deleting the browser's food data: the changes not yet sent wait there, and go once the same user
 * signs in again. Signing in as someone else deletes them then.
 */
export const sessionExpired = ({ reload = () => window.location.reload() } = {}) => (dispatch) => signOut(dispatch, false, reload);

const signOut = (dispatch, forgetData, reload) => {
	dispatch({
		type: LOGOUT_BEGIN
	});
	// The food store's copy first: it never rejects, and it stops other tabs writing another one.
	return (forgetData ? dispatch(forgetFoodData()) : Promise.resolve())
		.then(() => clearCaches())
		.finally(() => {
			const result = Request.apiv1Post('player/logout');
			console.log('Logout result, not using the promise', result);
		})
		.then(() => {
			dispatch({
				type: LOGOUT_SUCCESS
			});
			reload();
			return true;
		});
};

export const resetCategories = () => (dispatch, getState) => {
	return Request.apiv1Post('budget/categories', {
		reset_all: true,
	});
};

export const highlightCategory = (category) => {
	return {
		type: HIGHLIGHTED_CATEGORY,
		payload: category
	};
};

export const unHighlightCategory = (category) => {
	return {
		type: UN_HIGHLIGHTED_CATEGORY,
		payload: category
	};
};

export const highlightTransaction = (transaction) => {
	return {
		type: HIGHLIGHTED_TRANSACTION,
		payload: transaction
	};
};
export const unHighlightTransaction = (transaction) => {
	return {
		type: UN_HIGHLIGHTED_TRANSACTION,
		payload: transaction
	};
};

export const categoryFlipTransactions = (category) => (dispatch) => {
	dispatch({
		type: CATEGORY_FLIP_TRANSACTIONS_BEGIN,
		payload: category.id
	});
	Request.apiv1Post('budget/categories', { id: category.id, flip_transactions: true })
		.then((response) => {
			dispatch({
				type: CATEGORY_FLIP_TRANSACTIONS_SUCCESS,
				payload: category.id,
			});
			dispatch(refreshData());
		})
		.catch((error) => {
			dispatch({
				type: CATEGORY_FLIP_TRANSACTIONS_ERROR,
				payload: error,
			});
			Request.generalJsonError(error);
		});
};

/**
 * Marks a category as a loan, or not, whichever group it is in. The flag is set before the save so
 * the checkbox follows the click, and put back if the server refuses it. The budget list draws from
 * clones of the categories, so the one it was cloned from is updated too.
 */
export const setCategoryIsLoan = (category, isLoan) => (dispatch) => {
	const targets = [category, category.original].filter(Boolean);
	const previous = !!category.is_loan;
	targets.forEach((target) => {
		target.is_loan = isLoan;
	});
	return Request.apiv1Post('budget/categories', { id: category.id, is_loan: isLoan })
		.then(() => {
			dispatch(refreshData());
		}, (error) => {
			targets.forEach((target) => {
				target.is_loan = previous;
			});
			Request.generalJsonError(error);
		});
};

/**
 * Saves a loan's terms for one month from the debt page, whichever month the budget is showing: its
 * balance, rate and minimum on that month's budget row, and, when given, the row's note and the
 * loan's down payment rows, which are the loan's own. Only the fields passed are sent, so the month's
 * budgeted amount is left alone. An empty or zero amount clears it, as does an empty rate. A down
 * payment row left at zero is dropped, and the rows sent replace the loan's.
 *
 * Rejects when the server refuses, after saying so, so the form can stay open.
 *
 * @param {Object} terms `balance` and `minimum` in cents; `rate` and `note` strings; `downPayments`
 *     a list of `{kind, amount, note}`, amount in cents
 */
export const saveLoanTerms = (category, date, terms) => (dispatch) => {
	const cents = (amount) => (Number(amount) > 0 ? Math.round(Number(amount)) : -1);
	const month = {
		category_id: category.id,
		year: date.year(),
		month: date.month() + 1,
	};
	if(terms.balance !== undefined) {
		month.fund_total = cents(terms.balance);
	}
	if(terms.rate !== undefined) {
		month.interest_amount = String(terms.rate ?? '').trim();
	}
	if(terms.minimum !== undefined) {
		month.minimum_payment = cents(terms.minimum);
	}
	if(terms.note !== undefined) {
		month.notes = terms.note ?? '';
	}
	const saves = [Request.apiv1Post('budget/budgets', month)];
	if(terms.downPayments !== undefined) {
		const rows = terms.downPayments
			.filter((row) => Number(row.amount) > 0)
			.map((row) => ({ kind: row.kind, amount: Math.round(Number(row.amount)), note: String(row.note ?? '').trim() || null }));
		saves.push(Request.apiv1Post('budget/loan_down_payments', { category_id: category.id, down_payments: JSON.stringify(rows) }));
	}
	return Promise.all(saves)
		.then(() => {
			dispatch(refreshData());
		}, (error) => {
			Request.generalJsonError(error);
			throw error;
		});
};

export const summaryTabChanged = (tab) => {
	return {
		type: SUMMARY_PAGE_TAB_CHANGE,
		payload: tab
	};
};

export const setTransactionToEditMode = (transaction, options = {}) => {
	console.log('editing', transaction);
	return {
		type: START_TRANSACTION_EDIT_MODE,
		payload: {
			transaction,
			options,
		}
	};
};

export const endTransactionEditMode = () => {
	return {
		type: END_TRANSACTION_EDIT_MODE
	};
};

/**
 * This is the function that adds transactions to the update queue!
 */
export const updateTemporaryTransaction = (old, newTransaction, keepSubmitId = true) => {
	return {
		type: REPLACE_PREVIOUS_TRANSACTION,
		payload: {
			old,
			newTransaction,
			keepSubmitId
		}
	};
};

export const addTemporaryTransaction = (transaction) => {
	console.log('adding temporary transaction...', transaction);
	return {
		type: ADD_CLONED_TRANSACTION,
		payload: transaction
	};
};

export const deleteAllTransactionsPopupInitiate = () => {
	return {
		type: DELETE_ALL_TRANSACTIONS_POPUP_SHOW
	};
};

export const deleteAllTransactionsPopupEnd = () => {
	return {
		type: DELETE_ALL_TRANSACTIONS_POPUP_HIDE
	};
};

export const deleteAllTransactionsGo = () => (dispatch, getState) => {
	const { selectedDate } = getState().dashboard;
	dispatch({
		type: DELETE_ALL_TRANSACTIONS_BEGIN
	});
	return Request.apiv1Post('budget/transactions', {
			delete_all: true,
			month: selectedDate.month() + 1,
			year: selectedDate.year()
		})
		.then((response) => {
			dispatch({
				type: DELETE_ALL_TRANSACTIONS_SUCCESS
			});
			dispatch(refreshData());
		})
		.catch((error) => {
			Request.generalJsonError(error);
			dispatch({
				type: DELETE_ALL_TRANSACTIONS_FAIL
			});
			throw error;
		});
};

export const hideBankTransaction = (bankTransaction, hide = true) => (dispatch, getState) => {
	bankTransaction.hidden = hide;
	dispatch({
		type: HIDE_BANK_TRANSACTION_BEGIN,
		payload: hide && bankTransaction
	});
	Request.apiv1Post('plaid/hide_transaction', {
			plaid_transaction_id: bankTransaction.plaid_transaction_id,
			hide: hide
		})
		.then(() => {
			dispatch({
				type: HIDE_BANK_TRANSACTION_SUCCESS,
				payload: hide && bankTransaction,
			});
		})
		.catch((error) => {
			dispatch({
				type: HIDE_BANK_TRANSACTION_FAIL
			});
			console.error(error);
		});
};

export const unhideBankTransaction = (bankTransaction) => (dispatch) => {
	dispatch(hideBankTransaction(bankTransaction, false));
};

export const lastEditedTransactionChanged = (transactionId) => {
	return {
		type: LAST_EDITED_TRANSACTION_CHANGED,
		payload: transactionId,
	};
};

export const setCategoryAsSubgroupToCategoryModeActive = (category) => {
	return {
		type: SET_CATEGORY_AS_SUBGROUP_MODE_ACTIVE,
		payload: category
	};
};
export const endSetAsSubgroupMode = (category) => {
	return {
		type: SET_CATEGORY_AS_SUBGROUP_MODE_DEACTIVE,
	};
};

export const cancelledAddAsBankTransaction = (bankTransaction) => {
	return {
		type: ADD_BANK_TRANSACTION_AS_TRANSACTION_CANCELLED,
		payload: bankTransaction
	};
};

export const addBankTransactionAsTransaction = (bankTransaction) => {
	console.log('the plaid transaction', bankTransaction);
	const newTransaction = bankTransaction.createTransaction();
	return {
		type: ADD_BANK_TRANSACTION_AS_TRANSACTION_SUCCESS,
		payload: newTransaction,
	};
};

export const refreshDataAddToCacheOnly = () => (dispatch, getState) => {
	console.error('Adding to cache only!!!?');
	dispatch(refreshData(false, false));
};
export const refreshData = (attemptCacheFirst = false, updateLocalDisplays = true) => (dispatch, getState) => {
	const categoryGroups = new Map();
	const transactions = [];
	const categories = new Map();
	const { transactionFinder } = getState().dashboard;

	let apiGet = null;
	if(attemptCacheFirst) {
		apiGet = Request.apiv1GetFromCache;
	} else {
		apiGet = Request.apiv1Get;
	}

	if(attemptCacheFirst) {
		dispatch({
			type: UPDATE_REFRESH_CACHE_CHECK_BEGIN
		});
	}
	dispatch({
		type: UPDATE_CATEGORY_GROUPS_BEGIN
	});
	return apiGet('budget/categories')
		.then((response) => {
			_.each(response.category_groups, (categoryGroup) => {
				categoryGroups.set(categoryGroup.id, CategoryGroup.create(categoryGroup));
			});
			_.each(response.categories, (category) => {
				category = Category.create(category);
				category.setTransactionFinder(transactionFinder);
				categories.set(category.id, category);
			});
			updateCategoriesAndGroups(categories, categoryGroups);
			return [categoryGroups, categories];
		})
		.then(([categoryGroups, categories]) => {
			dispatch({
				type: UPDATE_TRANSACTIONS_BEGIN
			});
			return apiGet('budget/transactions')
				.then((response) => {
					_.each(response.plaid_accounts, (plaidBankAccount) => {
						//Cache the account.
						plaidBankAccount = PlaidBankAccount.retrieve(plaidBankAccount);
					});
					_.each(response.plaid_transactions, (plaidTransaction) => {
						plaidTransaction = PlaidTransaction.create(plaidTransaction);
						transactionFinder.plaidTransactions.addTransaction(plaidTransaction);
					});
					_.each(response.transactions, (transaction) => {
						transaction = Transaction.create(transaction);
						transactions.push(transaction);
					});
					if(updateLocalDisplays) {
						transactionFinder.setTransactions(transactions);
					}
					return [categoryGroups, categories, transactions];
				});
		})
		.then(([categoryGroups, categories]) => {
			return transactionFinder.loadOfflineTransactions().then(() => {
				console.log('we have loaded the transactions!');
				return [categoryGroups, categories, transactionFinder.getAllTransactions()];
			});
		})
		.then(([categoryGroups, categories, transactions]) => {
			dispatch({
				type: UPDATE_BUDGETS_BEGIN
			});
			return apiGet('budget/budgets')
				.then((response) => {
					const budgets = [];
					_.each(response.budgets, (budget) => {
						budget = Budget.create(budget);
						budgets.push(budget);
						const category = categories.get(budget.category_id);
						if(category) {
							category.addBudget(budget);
						}
					});
					return { categoryGroups, categories, budgets, transactions };
				});
		})
		.then((payload) => {
			dispatch({
				type: UPDATE_REFRESH_SUCCESS,
				payload: updateLocalDisplays ? payload : {},
			});

			if(attemptCacheFirst) {
				console.log('first load, cache success, attempt for real data');
				dispatch({
					type: UPDATE_REFRESH_CACHE_CHECK_SUCCESS
				});
				dispatch(refreshData());
			}
		})
		.catch((error) => {
			console.error(error);
			if(attemptCacheFirst) {
				dispatch({
					type: UPDATE_REFRESH_CACHE_CHECK_FAIL
				});
				console.error('first load, failed with cache, attempt again');
				dispatch(refreshData());
			} else {
				dispatch({
					type: UPDATE_REFRESH_FAIL
				});
			}
		});
};

const updateCategoriesAndGroups = (categories, categoryGroups) => {
	for(let [id, categoryGroup] of categoryGroups) {
		categoryGroup.resetCategories();
	}
	for(let [id, category] of categories) {
		const categoryGroup = categoryGroups.get(category.category_group_id);
		if(categoryGroup) {
			categoryGroup.addCategory(category);
		}
	}
	for(let [id, categoryGroup] of categoryGroups) {
		categoryGroup.sortCategories();
	}
};

export const connectionIsOnline = () => {
	return {
		type: CONNECTION_ONLINE
	};
};
export const connectionIsOffline = () => {
	return {
		type: CONNECTION_OFFLINE
	};
};
/** Keeps `dashboard.isOnline` in step with the browser's online and offline events. Returns the unsubscribe. */
export const watchConnection = (dispatch, target = window) => {
	const online = () => dispatch(connectionIsOnline());
	const offline = () => dispatch(connectionIsOffline());
	target.addEventListener('online', online);
	target.addEventListener('offline', offline);
	return () => {
		target.removeEventListener('online', online);
		target.removeEventListener('offline', offline);
	};
};

export const setPlayer = (player) => (dispatch, getState) => {
	dispatch({
		type: SET_PLAYER,
		payload: player
	});
};

export const createdAccount = () => (dispatch) => {
	dispatch({
		type: CREATED_ACCOUNT
	});
	dispatch(refreshData());
};

export const signedIn = () => (dispatch) => {
	dispatch({
		type: SIGNED_IN
	});
	dispatch(refreshData());
};


export const changeBudgetListMode = (mode) => {
	console.log('the mode is now', mode);
	return {
		type: CHANGE_BUDGET_LIST_MODE,
		payload: mode
	};
};
export const changeBudgetListModeToEditAmounts = () => {
	return changeBudgetListMode(BudgetListModes.AMOUNTS);
};
export const changeBudgetListModeToTypes = () => {
	return changeBudgetListMode(BudgetListModes.TYPES);
};
export const changeBudgetListModeToDashboard = () => {
	return changeBudgetListMode(BudgetListModes.DASHBOARD);
};

export const submitBudgetUpdate = (category, budget) => async(dispatch, getState) => {
	const { selectedDate } = getState().dashboard;
	const { deleteEdit } = category;

	let data = {};
	if(deleteEdit !== null) {
		data = {
			id: category.id,
			['delete']: deleteEdit,
		};
	} else {
		data = {
			year: selectedDate.year(),
			month: selectedDate.month() + 1,
			category_id: category.id,
			amount: budget.amount,
			notes: budget.notes,
			fund_total: budget.fund_total,
			interest_amount: budget.interest_amount,
			minimum_payment: budget.minimum_payment,
			show_when_not_used: budget.show_when_not_used,
			rollover_state: budget.rollover_state,
		};
	}

	dispatch({
		type: SUBMIT_CATEGORY_BUDGET_UPDATE_BEGIN,
		payload: {
			categoryId: category.id,
			updatedBudget: null,
		},
	}); // Hack to make undo action happen?
	dispatch({
		type: SUBMIT_CATEGORY_BUDGET_UPDATE_BEGIN,
		payload: {
			categoryId: category.id,
			updatedBudget: budget,
		},
	});
	return Request.apiv1Post('budget/budgets', data)
		.then((response) => {
			// this.refreshData();
			budget.update(response.budget);
			if(budget.original) {
				budget.original.update(response.budget);
			}
			dispatch({
				type: SUBMIT_CATEGORY_BUDGET_UPDATE_SUCCESS,
				payload: category.id,
			});
		})
		.catch((error) => {
			console.error(error);
			dispatch({
				type: SUBMIT_CATEGORY_BUDGET_UPDATE_ERROR,
				payload: category.id,
			});
		});
};

export const saveAllUpdatedBudgetsForCategoryGroup = (categoryGroup, categoryBudgetMap) => async(dispatch, getState) => {
	dispatch({
		type: SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_BEGIN,
		payload: categoryGroup.id,
	});
	const budgetsToUpdate = [];
	categoryBudgetMap.forEach((budget, category) => {
		if(!budget.hasChanges()) {
			return;
		}
		budgetsToUpdate.push({
			category,
			budget
		});
	});
	console.log('budgets to update', budgetsToUpdate);
	for(let budgetToUpdate of budgetsToUpdate) {
		const theResult = await dispatch(submitBudgetUpdate(budgetToUpdate.category, budgetToUpdate.budget));
		console.log('waht si the reesult', theResult);
	}
	dispatch({
		type: SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_SUCCESS,
		payload: categoryGroup.id,
	});
	// dispatch({
	// 	type: SAVE_ALL_CHANGED_BUDGETS_FOR_CATEGORY_GROUP_ERROR,
	// 	payload: categoryGroup.id,
	// });
};

export const decreaseSelectedDateByOneMonth = () => (dispatch, getState) => {
	changeSelectedDateByAMonth('subtract', dispatch, getState);
};

export const increaseSelectedDateByOneMonth = () => (dispatch, getState) => {
	changeSelectedDateByAMonth('add', dispatch, getState);
};

const changeSelectedDateByAMonth = (addOrSubtract, dispatch, getState) => {
	const currentDate = getState().dashboard.selectedDate;
	if(!currentDate) {
		return;
	}
	let changed = null;
	switch(addOrSubtract) {
		case 'add':
			changed = currentDate.clone().add(1, 'months');
			break;
		case 'subtract':
			changed = currentDate.clone().subtract(1, 'months');
			break;
		default:
			throw new Error('Invalid option, expected add or subtract');
	}
	dispatch(updateSelectedDate(changed));
};

export const updateSelectedDate = (clickedDate, specialClicked) => (dispatch, getState) => {
	const { selectedDates, visibleDates, selectedMainTab } = getState().dashboard;
	let updatedSelectedDates = null;
	if(specialClicked) {
		updatedSelectedDates = { ...selectedDates };

		let firstSelected = null;
		let lastSelected = null;
		for(let possibleDate of visibleDates) {
			if(dateIsSelected(selectedDates, possibleDate)) {
				if(!firstSelected) {
					firstSelected = possibleDate;
				}
				lastSelected = possibleDate;
			}
		}

		if(dateIsSelected(selectedDates, clickedDate) && _.size(selectedDates) > 1) {
			delete updatedSelectedDates[DateHelper.yearMonthSerialize(clickedDate)];
		} else {
			const selectBetweenerDates = (visibleDates) => {
				let foundClickedDate = false;
				for(let possibleDate of visibleDates) {
					if(DateHelper.yearMonthSerialize(possibleDate) === DateHelper.yearMonthSerialize(clickedDate)) {
						foundClickedDate = true;
					}
					if(updatedSelectedDates[DateHelper.yearMonthSerialize(possibleDate)]) {
						break;
					}
					if(foundClickedDate) {
						updatedSelectedDates[DateHelper.yearMonthSerialize(possibleDate)] = possibleDate;
					}
				}
			};
			if(clickedDate.isBefore(firstSelected)) {
				selectBetweenerDates(visibleDates);
			} else if(clickedDate.isAfter(lastSelected)) {
				selectBetweenerDates(visibleDates.reverse());
			}
		}

		LadderLocalStorage.setItem('selectedDates', updatedSelectedDates);
	} else {
		updatedSelectedDates = {
			[DateHelper.yearMonthSerialize(clickedDate)]: null
		};
		LadderLocalStorage.setItem('selectedDates', updatedSelectedDates);
		updatedSelectedDates = {
			[DateHelper.yearMonthSerialize(clickedDate)]: clickedDate
		};

	}
	dispatch({
		type: UPDATE_SELECTED_DATE,
		payload: {
			selectedDates: updatedSelectedDates,
			windowState: getState().windowSize,
		},
	});

	dispatch(retrieveBankAccountTransactionsIfNecessary());
};

/**
 * Selects every month from one to the other. Unlike a special click through updateSelectedDate(),
 * this does not walk visibleDates, so the range can reach months the old strip never showed.
 */
export const selectMonthRange = (from, to) => (dispatch, getState) => {
	const selectedDates = selectionFromMonths(monthsBetween(from, to));
	LadderLocalStorage.setItem('selectedDates', selectedDates);
	dispatch({
		type: UPDATE_SELECTED_DATE,
		payload: {
			selectedDates,
			windowState: getState().windowSize,
		},
	});

	dispatch(retrieveBankAccountTransactionsIfNecessary());
};

const dateIsSelected = (selectedDates, date) => {
	return !!selectedDates[DateHelper.yearMonthSerialize(date)];
};
